import { Modal } from '@/components/ui/modal';
import React from 'react'

type Props = {
    open: boolean;
    handleModalClose: Function;
}

const DownloadReportModal = ({open, handleModalClose}: Props) => {
  return (
    <Modal
    open={open}
    handleClose={handleModalClose}
    title="Download Report"
  >
    <div>
    The report generation will start soon, once the report is generated the report will be send to your Email.
    </div>
    
  </Modal>
  )
}

export default DownloadReportModal